import { FC } from 'react';
import styles from './AiMessage.module.css';
import CopyIcon from '@/components/ui/icons/CopyIcon';
import { showToast } from '@/lib/functions/funcUtils';

interface AiMessageProps {
	text: string;
}

const AiMessage: FC<AiMessageProps> = ({ text }) => {
	const copyToClipboard = () => {
		navigator.clipboard.writeText(text);
		showToast('info', 'Response has been copied to your clipboard');
	};
	return (
		<div className={styles.card + ' my-2'}>
			<p className="text-[#6d7d86] text-left">{text}</p>
			<div className="flex justify-end">
				<CopyIcon
					onClick={copyToClipboard}
					className="cursor-pointer hover:scale-110"
				/>
			</div>
		</div>
	);
};

export default AiMessage;
